// LIbs
import styled, { css } from 'styled-components'

// Comps
import { fadeIn } from '../../utils/keyframes'
import { ModalContentWrapper } from './ModalContentWrapper'
import {
  colors,
  fontWeights,
  forScreensGreaterThanMobileWidth,
} from '../../utils'

export const PurchaseDiv = styled(ModalContentWrapper)`
  align-items: center;
  animation: ${fadeIn} 100ms ease;
  display: flex;
  justify-content: center;
  flex-direction: column;
  position: relative;
  pointer-events: all;
  height: 80vh;
  margin-top: 10vh;
  margin-bottom: 10vh;
  max-width: 600px;
  width: 100%;

  padding: 32px 0 16px;

  @media (min-width: 680px) {
    padding: 32px 36px 16px;
  }

  &.padding-0 {
    padding-top: 0;
    padding-bottom: 0;
  }
`

export const RefundDiv = styled(ModalContentWrapper)`
  align-items: center;
  animation: ${fadeIn} 100ms ease;
  display: flex;
  justify-content: center;
  flex-direction: column;

  /* Fix issue where pointer events don't work in new modal */
  position: relative;
  pointer-events: all;

  padding-top: 44px;
  padding-bottom: 44px;

  .header {
    width: 90%;
    margin-bottom: 20px;
  }

  .content {
    font-weight: ${fontWeights.normal};
    line-height: 130%;
    color: ${colors.veryDarkGray};
    width: 370px;
    max-width: 90%;
    text-align: center;
    margin-bottom: 37px;
  }

  .button {
    width: 263px;

    &.closeButton {
      margin-bottom: 27px;
    }
  }

  .refundButtonContainer {
    margin-bottom: 20px;
  }
  .buttonGroup {
    display: flex;

    flex-direction: column;
    row-gap: 20px;
    ${forScreensGreaterThanMobileWidth(css`
      flex-direction: row;
      column-gap: 12px;
    `)}
  }

  .detail {
    width: 263px;
    margin-top: 5px;
  }

  .termsCondition {
    width: 458px;
    text-align: center;
    margin-bottom: 19px;
    color: ${colors.veryDarkGray};
    font-size: 12px;
    line-height: 140%;
    letter-spacing: -0.5px;
  }

  & .refundError {
    color: ${colors.red};
  }
`
